import React from 'react';

export function TmCustomerCardPage() {
  return <div>TmCustomerCard</div>;
}
